export default __webpack_public_path__ + "static/media/typeAnswer.07f1c6dc.png";